import { TenantsState } from '@core/sso/store/states/tenants.state';

export const tenantsState = [TenantsState];
